import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../shared/hooks/useToast";
import theme from "@shared/utils/themeColors";

/**
 * Cancel page after abandoning a subscription payment
 */
const SubscriptionCancelPage: React.FC = () => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [hasShownToast, setHasShownToast] = useState(false);

  useEffect(() => {
    if (!hasShownToast) {
      // Show a message about the canceled payment
      showToast("Payment process was canceled.", "info");
      setHasShownToast(true);
    }

    // Redirect after a short delay
    const timer = setTimeout(() => {
      navigate("/settings/plans");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, showToast, hasShownToast]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className={`w-full max-w-md p-8 space-y-8 ${theme.bg.primary} rounded-lg shadow-md`}>
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            Payment Canceled
          </h1>

          <div className="flex justify-center mb-4">
            <svg
              className="h-16 w-16 text-yellow-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              ></path>
            </svg>
          </div>

          <p className="text-gray-600 dark:text-gray-300">
            Your payment process was canceled. No charges were made.
          </p>

          <p className="mt-4 text-gray-600 dark:text-gray-300">
            You will be redirected to the subscription page in a few seconds.
          </p>

          <button
            onClick={() => navigate("/settings/plans")}
            className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Return to Subscription Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
